import { GET_DASHBOARD_OVERVIEW_DATA, GET_DASHBOARD_OVERVIEW_DATA_FAILURE, GET_DASHBOARD_OVERVIEW_DATA_SUCCESS, GET_USER_PROJECT_MANAGER_WORKER_DATA, GET_USER_PROJECT_MANAGER_WORKER_DATA_FAILURE, GET_USER_PROJECT_MANAGER_WORKER_DATA_SUCCESS, SET_DASHBOARD_FLAG } from "../storeTypes";

export const getDashboardOverviewData = (payload) => {
    return {
        type: GET_DASHBOARD_OVERVIEW_DATA,
        payload
    }
}
export const getDashboardOverviewDataSuccess = (payload) => {
    return {
        type: GET_DASHBOARD_OVERVIEW_DATA_SUCCESS,
        payload: payload,
    }
};

export const getDashboardOverviewDataFailure = (payload) => {
    return {
        type: GET_DASHBOARD_OVERVIEW_DATA_FAILURE,
        payload: payload,
    }
};
export const setDashboardFlag = (flag) => {
    return {
        type: SET_DASHBOARD_FLAG,
        payload: flag,
    };
};
export const getUserProjectManagerWorkerData = (url, chartKey) => {
    return {
        type: GET_USER_PROJECT_MANAGER_WORKER_DATA,
        payload: { url, chartKey }
    }
}
export const getUserProjectManagerWorkerDataSuccess = (payload) => {
    return {
        type: GET_USER_PROJECT_MANAGER_WORKER_DATA_SUCCESS,
        payload: payload,
    }
};
export const getUserProjectManagerWorkerDataFailure = (payload) => {
    return {
        type: GET_USER_PROJECT_MANAGER_WORKER_DATA_FAILURE,
        payload: payload,
    }
};
